<script>
import { mapState, mapWritableState } from "pinia";
import { useAppStore } from "@/app-store/app";
import NewModal from "@/components/UI/NewModal.vue";
import { getLayoutStyling } from "@/utils/Styling";
import UIButton from "@/components/UI/UIButton.vue";

export default {
  name: "LandingRestrictionModal",
  components: {
    UIButton,
    NewModal,
  },
  computed: {
    ...mapWritableState(useAppStore, ["isLandingRestrictionOpen"]),
    ...mapState(useAppStore, ["layoutConfig", "landingRestriction"]),
    styleVars() {
      const { layoutConfig, screenYOverflow } = this;
      return {
        ...getLayoutStyling(layoutConfig, screenYOverflow),
        height: this.baseHeight,
      };
    },
    bgClass() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar) return "bg-color-first";
      return `bg-color-${layoutConfig.actionbar.containerColor}`;
    },
    titleClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-black";
      return `font-${layoutConfig.actionbar.titleFont} max-md:text-xl md:text-${layoutConfig.actionbar.titleTextSize} text-color-${layoutConfig.actionbar.titleTextColor}`;
    },
    subtitleClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-black";
      return `font-${layoutConfig.actionbar.subtitleFont} max-md:text-xl md:text-${layoutConfig.actionbar.subtitleTextSize} text-color-${layoutConfig.actionbar.subtitleTextColor}`;
    },
    textClass() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "text-color-first font-first text-base";
      return `text-color-${layoutConfig.actionbar.textColor} font-${layoutConfig.actionbar.font} text-${layoutConfig.actionbar.textSize}`;
    },
    primaryButtonClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-white";
      let shapeClass = "rounded-none";
      switch (layoutConfig.actionbar.primaryButtonShape) {
        case "rounded":
          shapeClass = "rounded-xl";
          break;
        case "full-rounded":
          shapeClass = "rounded-full";
          break;
      }
      return `${shapeClass} bg-color-${layoutConfig.actionbar.primaryButtonBackgroundColor} text-color-${layoutConfig.actionbar.primaryButtonTextColor} font-${layoutConfig.actionbar.primaryButtonFont} border-2 border-color-${layoutConfig.actionbar.primaryButtonBorderColor} max-md:text-xl md:text-${layoutConfig.actionbar.primaryButtonTextSize}`;
    },
    secondaryButtonClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-white";
      let shapeClass = "rounded-none";
      switch (layoutConfig.actionbar.secondaryButtonShape) {
        case "rounded":
          shapeClass = "rounded-xl";
          break;
        case "full-rounded":
          shapeClass = "rounded-full";
          break;
      }
      return `${shapeClass} bg-color-${layoutConfig.actionbar.secondaryButtonBackgroundColor} text-color-${layoutConfig.actionbar.secondaryButtonTextColor} font-${layoutConfig.actionbar.secondaryButtonFont} border-2 border-color-${layoutConfig.actionbar.secondaryButtonBorderColor} max-md:text-xl md:text-${layoutConfig.actionbar.secondaryButtonTextSize}`;
    },
  },
  data: () => ({
    agreed: false,
  }),
  methods: {
    onOK() {
      if (this.landingRestriction.confirmOnAllVisits) {
        window.sessionStorage.setItem("agreedRestriction", "true");
      } else {
        window.localStorage.setItem("agreedRestriction", "true");
      }
      this.isLandingRestrictionOpen = false;
    },
    onCancel() {
      this.agreed = true;
    },
    onTakeMeOut() {
      window.location.replace("https://www.google.com/");
    },
  },
};
</script>

<template>
  <new-modal v-model="isLandingRestrictionOpen">
    <div :style="styleVars">
      <div
        :class="`p-3 flex flex-col text-center gap-2 ${bgClass}`"
        v-if="!agreed"
      >
        <div :class="`${titleClasses}`">{{ landingRestriction.title }}</div>
        <div
          id="restriction-question"
          :class="`${textClass}`"
          v-html="landingRestriction?.question"
        ></div>
        <div class="grid grid-cols-2 gap-5">
          <u-i-button
            @click="onCancel"
            :class="`w-full ${secondaryButtonClasses}`"
          >
            {{ landingRestriction.cancelText }}
          </u-i-button>
          <u-i-button @click="onOK" :class="`w-full ${primaryButtonClasses}`">
            {{ landingRestriction.okText }}</u-i-button
          >
        </div>
      </div>
      <div v-else :class="`p-3 flex flex-col text-center gap-2 ${bgClass}`">
        <div
          :class="`${textClass}`"
          v-html="landingRestriction.cancellationDescription"
        ></div>
        <u-i-button
          @click="onTakeMeOut"
          :class="`w-full ${primaryButtonClasses}`"
        >
          {{ landingRestriction.cancellationText }}</u-i-button
        >
      </div>
    </div>
  </new-modal>
</template>

<style>
#restriction-question a {
  @apply font-bold;
}
</style>
